import {Component, Input} from '@angular/core';
import {ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-select-field',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    NgForOf
  ],
  templateUrl: './select-field.component.html',
  styleUrl: './select-field.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class SelectFieldComponent {

  @Input() label: string = '';
  @Input() controlName: string = '';
  @Input() required: boolean = false;
  @Input() options: { id: any; name: string }[] = []; // Array of options with id and name
  @Input() placeholder: string = 'Select an option';

  constructor(public controlContainer: FormGroupDirective) {}

  get formControl(): FormControl {
    return this.controlContainer.control.get(this.controlName) as FormControl;
  }

}
